module.exports = __webpack_public_path__ + "static/media/Pardubice_logo_1C.b8dbeb11.png";